<template>
    <div>
        <div v-for="dataset in props.data.datasets" :key="dataset.label" class="flex items-center">
            <div class="grow-0 mr-2">
                <div class="relative w-6 h-20 overflow-hidden bg-white border-4 border-gray-800 rounded-full">
                    <div
                        class="absolute inset-x-0 bottom-0"
                        :style="{ height: `${percent}%` }"
                        :class="[`bg-${color}-400`]"
                    ></div>
                </div>
            </div>
            <div class="grow-0 text-4xl font-semibold">
                {{ dataset.data[0] }}
            </div>
            <div class="flex-auto pl-4 text-xs max-w-[40px]">
                {{ dataset.label }}
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

interface Props {
    data?: any;
    minValue?: number;
    maxValue?: number;
}

const props = withDefaults(defineProps<Props>(), {
    data: null,
    minValue: -10,
    maxValue: 50,
});

const percent = computed(() => {
    return Math.round(((props.data.datasets[0].data[0] - props.minValue) / (props.maxValue - props.minValue)) * 100);
});

const color = computed(() => {
    if (percent.value < 25) {
        return 'blue';
    } else if (percent.value < 50) {
        return 'green';
    } else if (percent.value < 75) {
        return 'yellow';
    } else {
        return 'red';
    }
});
</script>
